
import React from 'react';
import { WeatherQuote } from '@/types/weather';
import { motion } from 'framer-motion';

interface WeatherQuoteDisplayProps {
  quote: WeatherQuote | null;
  isMultiDay?: boolean;
}

const WeatherQuoteDisplay: React.FC<WeatherQuoteDisplayProps> = ({ quote, isMultiDay }) => {
  if (!quote) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="my-4 p-3 rounded-lg text-center bg-black/30 backdrop-blur-sm"
    >
      <p className="text-lg italic font-light drop-shadow-lg">{quote.en}</p>
      {quote.author && (
        <p className="text-sm mt-1 opacity-90 drop-shadow-md">— {quote.author}</p>
      )}
    </motion.div>
  );
};

export default WeatherQuoteDisplay;
